// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var FeedbackSubmissionAction = function (x) {
    return x;
};
var tsBridgeFeedbackSubmissio = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("FeedbackSubmissionAction")("__brandFeedbackSubmissionAction"));
        });
    }
};
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.FeedbackSubmission (line 85, column 7 - line 87, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.feedbackErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runFormUpdates = function (env) {
    return Ouroboros_Services_Clients_Interop_IO.chain(function (v) {
        return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.showSuccess))(true);
    })(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.feedbackContents))(""));
};
var runFeedbackSubmissionAction = function (v) {
    return v;
};
var runBackToHome = function (env) {
    return function (route) {
        return Ouroboros_Services_Clients_Interop_IO.chain(function (v) {
            return runNavigate(env.navigate)(route);
        })(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.showSuccess))(false));
    };
};
var mkFeedbackSubmissionAction = FeedbackSubmissionAction;
var handleFeedbackError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var submitAndHandle = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleFeedbackError(env))(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runFormUpdates(env));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess)));
        })(env.feedbackClient.submitFeedback(request));
    };
};
var submitFeedbackTask = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return submitAndHandle(env)(request);
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var mkFeedbackSubmissionController = function (env) {
    return {
        submit: function (request) {
            return mkFeedbackSubmissionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitFeedbackTask(env)(request)));
        },
        updateFeedbackContents: function (value) {
            return mkFeedbackSubmissionAction(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.feedbackContents))(value));
        },
        closeSuccessModal: mkFeedbackSubmissionAction(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.form.showSuccess))(false)),
        backToHome: function (route) {
            return mkFeedbackSubmissionAction(runBackToHome(env)(route));
        }
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/feedback_submission_controller.md";
export {
    FeedbackSubmissionAction,
    mkFeedbackSubmissionController,
    runFeedbackSubmissionAction,
    documentationPath,
    tsBridgeFeedbackSubmissio
};
//# sourceMappingURL=index.js.map
